var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{class:_vm.wrapperClassName},[(_vm.headerfooter)?_c('HeaderIndex'):_vm._e(),_c('router-view'),(_vm.headerfooter)?_c('FooterIndex'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }